import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-icon';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';

/**
 * @element bh-expandable-content
 */
@customElement('bh-expandable-content')
export class BhSelectableCard extends BuchungsheldLitElement {
  @property({ type: Number }) cutOffHeightInPx = 50;

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
        '.content': {
          '--scale': '1',
          maskImage: this.expanded
            ? 'unset'
            : `linear-gradient(180deg,
            black  0%,
            black ${this.cutOffHeightInPx - 40}px,
            transparent ${this.cutOffHeightInPx}px
          )`,
        },
      },
    ];
  }

  @state() private expanded = false;
  @state() private toggleEnabled = false;

  private slotRef = createRef<HTMLSlotElement>();

  override connectedCallback(): void {
    super.connectedCallback();
    setTimeout(() => {
      const slot = this.slotRef.value;
      if (!slot) {
        console.warn('could not get ref');
        return;
      }

      // @ts-expect-error cant infer node type
      const childrenHeight = slot.assignedNodes().reduce((sum, node) => sum + (node.offsetHeight ?? 0), 0);
      this.toggleEnabled = childrenHeight > this.cutOffHeightInPx + 30;
      if (!this.toggleEnabled) this.expanded = true; // make sure content is visible when toggle is not available
    }, 0);
  }

  override render() {
    return html`<div
      ${css({
        overflow: 'hidden',
        position: 'relative',
        maxHeight: this.expanded ? 'unset' : this.cutOffHeightInPx + 'px',
        paddingBottom: this.toggleEnabled ? '30px' : '0',
      })}
    >
      <!-- contents -->
      <div class="content">
        <slot ${ref(this.slotRef)}></slot>
      </div>

      <!-- button -->
      <tr-button
        mode="text"
        ${css({
          position: 'absolute',
          bottom: '0px',
          fontWeight: 'bold',
          opacity: '.7',
          display: this.toggleEnabled ? 'flex' : 'none',
        })}
        @click=${e => {
          this.expanded = !this.expanded;
          e.stopPropagation();
        }}
        icon=${this.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
      >
        ${this.expanded ? this._translation.translate('show_less') : this._translation.translate('show_more')}
      </tr-button>
    </div>`;
  }
}
